export default {"src":"/_next/static/media/wishlist-gray-filled.091dca10.svg","height":20,"width":23,"blurWidth":0,"blurHeight":0};